import React from 'react';
import { Grid } from '@mui/material';
import HeaderSection from '../../sections/dashboard/HeaderSection';
import SmeNavigationBoxSection from '../../sections/dashboard/SmeNavigationBoxSection';
import StatsSection from '../../sections/dashboard/StatsSection';
import ChartsSection from '../../sections/dashboard/ChartsSection';
import i18n from '../../i18';

export default class SmeAdminDashboardContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        };
    }

    render() {
        const { data } = this.state;
        const { navigate } = this.props;
        const transactionVolumesByDate = data?.transactionVolumesByDate || {};
        const datesLabelsTransactionVolumes =
            data?.datesLabelsTransactionVolumes || [];
        const totalActiveWallets = data?.totalActiveWallets || 0;
        const totalInactiveWallets = data?.totalInactiveWallets || 0;

        const statsData = [
            {
                path: '/app/sme-company-employees',
                title: i18n.t('dashboard.totalUsers'),
                subtitle: i18n.t('dashboard.totalUsersSubtitle'),
                total: data?.totalUsers || 0,
                gradient: 'primary'
            },
            {
                title: i18n.t('dashboard.totalActiveWallets'),
                subtitle: i18n.t('dashboard.totalActiveWalletsSubtitle'),
                total: totalActiveWallets,
                gradient: 'secondary'
            },
            {
                path: '/app/transactions',
                title: i18n.t('dashboard.totalTransactionsCount'),
                subtitle: i18n.t('dashboard.totalTransactionsCountSubtitle'),
                total: data?.totalTransactionsCount || 0,
                gradient: 'info'
            }
        ];

        const headerActions = [];

        return (
            <Grid container spacing={3}>
                <HeaderSection
                    currentUser={data?.currentUser}
                    actions={headerActions}
                />
                {/* <SmeNavigationBoxSection navigate={navigate} /> */}
                <StatsSection statsData={statsData} />
                <ChartsSection
                    transactionVolumesByDate={transactionVolumesByDate}
                    datesLabelsTransactionVolumes={
                        datesLabelsTransactionVolumes
                    }
                    totalActiveWallets={totalActiveWallets}
                    totalInactiveWallets={totalInactiveWallets}
                />
            </Grid>
        );
    }
}
